import Scrollbar, { ScrollbarProps } from "./Scrollbar"

export {
  Scrollbar,
}

export type {
  ScrollbarProps,
}